import { useEffect, useRef, useState } from "react";
// import CommonTabs from "../common-components";
import { Link, useLocation, useParams } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
// import CrmsModal from "../../../core/modals/crms_modal";
import api from "../../../services/api";
import Loader from "../../../core/common/loader";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import html2canvas from "html2canvas";

const CompaniesDetails = () => {
  const location = useLocation();
  const { id } = useParams();
  const [selectedCompany, setSelectedCompany] = useState<any | null>(null);

  useEffect(() => {
    const signature = localStorage.getItem("signature");

    // This will run when the component mounts
    const fetchDashboardData = async () => {
      try {
        const [companyDetails] = await Promise.all([
          api.post("userService/getCompanyDetailById", { signature, id }),
        ]);

        setSelectedCompany(companyDetails.data.data.data);
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      }
    };

    fetchDashboardData();
  }, []);

  const handleCopyEmail = () => {
    if (selectedCompany?.Email) {
      navigator.clipboard
        .writeText(selectedCompany.Email)
        .then(() => {
          toast.success("Email copied to clipboard!", {
            position: "top-right",
          });
        })
        .catch((err) => {
          console.error("Failed to copy email: ", err);
        });
    }
  };

  const cardRef = useRef(null);
  const handleShareAsImage = async () => {
    if (cardRef.current) {
      try {
        const canvas = await html2canvas(cardRef.current);
        const image = canvas.toDataURL("image/png");

        // Trigger download or share the image
        const link = document.createElement("a");
        link.href = image;
        link.download = `${selectedCompany.Company_Name || "company"}.png`;
        link.click();
      } catch (error) {
        console.error("Error capturing the div as image:", error);
      }
    }
  };

  const routes = all_routes;

  if (selectedCompany == null) {
    return <Loader />;
  } else {
    return (
      <>
        <div className="page-wrapper">
          <div className="content">
            <div className="row align-items-center mb-4">
              <div className="col-sm-6">
                <h6 className="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0">
                  <Link to={`${routes.companiesGrid}${location?.search}`}>
                    <i className="ti ti-arrow-left me-2" />
                    Companies
                  </Link>
                  <span className="text-gray d-inline-flex ms-2">
                    / {selectedCompany.Company_Name}
                  </span>
                </h6>
              </div>
              <div className="col-sm-6">
                <div className="d-flex align-items-center justify-content-sm-end">
                  <div className="head-icons ms-2 mb-0">
                    <CollapseHeader />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-4 theiaStickySidebar">
                <div className="card card-bg-1 sticky-class" ref={cardRef}>
                  <div className="card-body p-0">
                    <span
                      className="avatar avatar-xl border bg-white rounded-circle m-auto d-flex align-items-center justify-content-center mb-2"
                      style={{ width: 80, height: 80 }}>
                      {selectedCompany.Image ? (
                        <ImageWithBasePath
                          src={selectedCompany.Image}
                          className="w-100 h-100 rounded-circle object-fit-cover"
                          alt="Img"
                        />
                      ) : (
                        <span
                          className="text-uppercase fw-bold text-primary"
                          style={{ fontSize: 28 }}>
                          {selectedCompany.Company_Name?.charAt(0)}
                        </span>
                      )}
                    </span>

                    <div className="text-center px-3 pb-3 border-bottom">
                      <h5 className="d-flex align-items-center justify-content-center mb-1">
                        {selectedCompany.Company_Name}
                        <i className="ti ti-discount-check-filled text-success ms-1" />
                      </h5>
                      <p className="text-dark">{selectedCompany.Address}</p>
                    </div>

                    <div className="p-3 border-bottom">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <h6>Basic information</h6>
                        {/* <Link
                          to="#"
                          className="btn btn-icon btn-sm"
                          data-bs-toggle="modal"
                          data-bs-target="#edit_company"
                        >
                          <i className="ti ti-edit" />
                        </Link> */}
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-phone me-2" />
                          Phone
                        </span>
                        <p className="text-dark">{selectedCompany.Phone}</p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-mail-check me-2" />
                          Email
                        </span>
                        <Link
                          to="#"
                          className="text-info d-inline-flex align-items-center"
                          onClick={(e) => e.preventDefault()} // Prevent navigation on clicking the link
                        >
                          {selectedCompany.Email}{" "}
                          <i
                            className="ti ti-copy text-dark ms-2"
                            onClick={handleCopyEmail} // Attach the copy functionality here
                            style={{ cursor: "pointer" }} // Make it look clickable
                          />
                        </Link>
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-gender-male me-2" />
                          Created On
                        </span>
                        <p className="text-dark">
                          {new Date(
                            selectedCompany.CreatedDate
                          ).toLocaleDateString()}
                        </p>
                      </div>
                    </div>
                    <div className="p-3 border-bottom">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <h6>Other Information</h6>
                      </div>

                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-mail-check me-2" />
                          Currency
                        </span>
                        <p className="text-dark">{selectedCompany.Location}</p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-globe me-2" />
                          Last Modified
                        </span>
                        <p className="text-dark">
                          {" "}
                          {new Date(
                            selectedCompany.UpdatedDate
                          ).toLocaleDateString()}
                        </p>
                      </div>
                    </div>
                    <div className="p-3">
                      {/* <div className="d-flex align-items-center justify-content-between mb-2">
                        <h6>Social Links</h6>
                        <Link to="#" className="btn btn-icon btn-sm">
                          <i className="ti ti-edit" />
                        </Link>
                      </div>
                      <div className="d-flex align-items-center mb-3">
                        <Link to="#" className="me-2">
                          <ImageWithBasePath
                            src="assets/img/social/social-01.svg"
                            alt="Img"
                          />
                        </Link>
                        <Link to="#" className="me-2">
                          <ImageWithBasePath
                            src="assets/img/social/social-06.svg"
                            alt="Img"
                          />
                        </Link>
                        <Link to="#" className="me-2">
                          <ImageWithBasePath
                            src="assets/img/social/social-02.svg"
                            alt="Img"
                          />
                        </Link>
                        <Link to="#" className="me-2">
                          <ImageWithBasePath
                            src="assets/img/social/social-03.svg"
                            alt="Img"
                          />
                        </Link>
                        <Link to="#" className="me-2">
                          <ImageWithBasePath
                            src="assets/img/social/social-04.svg"
                            alt="Img"
                          />
                        </Link>
                        <Link to="#" className="me-2">
                          <ImageWithBasePath
                            src="assets/img/social/social-05.svg"
                            alt="Img"
                          />
                        </Link>
                      </div> */}
                      <div className="row gx-2">
                        <div className="col-12">
                          <Link
                            to="#"
                            className="d-flex align-items-center justify-content-center btn btn-dark"
                            onClick={(e: any) => {
                              e.preventDefault();
                              handleShareAsImage();
                            }}>
                            <i className="ti ti-share-2 me-2" />
                            Share
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <CommonTabs /> */}
            </div>
          </div>
          <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
            <p className="mb-0">2025 © CMS.</p>
            <p>
              Designed & Developed By{" "}
              <Link
                to="#"
                onClick={(e: any) => e.preventDefault()}
                className="text-primary">
                ZYVO
              </Link>
            </p>
          </div>
        </div>
        {/* <CrmsModal /> */}
        <ToastContainer />
      </>
    );
  }
};

export default CompaniesDetails;
